import { render } from "./app-text-readmore.vue?vue&type=template&id=66fa78ec"
import script from "./app-text-readmore.vue?vue&type=script&lang=js"
export * from "./app-text-readmore.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/text/app-text-readmore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66fa78ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66fa78ec', __exports__)) {
    console.log('reload')
    api.reload('66fa78ec', __exports__)
  }
  
  module.hot.accept("./app-text-readmore.vue?vue&type=template&id=66fa78ec", () => {
    console.log('re-render')
    api.rerender('66fa78ec', render)
  })

}


export default __exports__